import script from "./API.vue?vue&type=script&setup=true&lang=js"
export * from "./API.vue?vue&type=script&setup=true&lang=js"

import "./API.vue?vue&type=style&index=0&id=01407704&lang=css"

const __exports__ = script;

export default __exports__